import type { OrderPriceResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { OrderPriceEditForm } from "Order/Modules/Price/Components/Form/OrderPriceEditForm";
import CustomFormLabel from "Shared/Components/Inputs/CustomFormLabel";
import CustomTextField from "Shared/Components/Inputs/CustomTextField";
import {
	Box,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	Grid2,
	Typography,
} from "@mui/material";
import { useState } from "react";

const orderResources = Resources.base.order.editForm;

type OrderPriceEditWidgetProps = {
	orderPrice: OrderPriceResponseDto;
	orderId: number;
	isMaterialPrice?: boolean;
	isDisabled?: boolean;
};

export function OrderPriceEditWidget({
	orderPrice,
	orderId,
	isMaterialPrice,
	isDisabled = false,
}: OrderPriceEditWidgetProps) {
	const { t } = useResource();
	const [isPriceModalOpen, setIsPriceModalOpen] = useState<boolean>(false);

	const handleOpenPriceModal = () => {
		setIsPriceModalOpen(true);
	};
	return (
		<Grid2 container spacing={2}>
			<Grid2 size={isMaterialPrice ? 4 : 12}>
				<CustomFormLabel>
					{isMaterialPrice ? "Labour price" : t(orderResources.price)}
				</CustomFormLabel>
				<CustomTextField
					value={orderPrice?.price}
					fullWidth
					disabled
					slotProps={{
						input: {
							endAdornment: (
								<Button
									variant="contained"
									sx={{
										minHeight: "41.61px",
										borderTopLeftRadius: 0,
										borderBottomLeftRadius: 0,
									}}
									disabled={isDisabled}
									onClick={handleOpenPriceModal}
								>
									{t(orderResources.change)}
								</Button>
							),
							sx: { p: 0 },
						},
					}}
				/>
			</Grid2>
			{isMaterialPrice && (
				<>
					<Grid2 size={4}>
						<CustomFormLabel>Material Price</CustomFormLabel>
						<CustomTextField
							disabled
							fullWidth
							value={orderPrice.materialPrice ?? ""}
						/>
					</Grid2>
					<Grid2 size={4}>
						<CustomFormLabel>Total Price</CustomFormLabel>
						<Box
							display="flex"
							alignItems="center"
							justifyContent="space-between"
							padding={1.2}
							border={1}
						>
							<Typography variant="subtitle2">
								{(orderPrice.price ?? 0) + (orderPrice.materialPrice ?? 0)}
							</Typography>
						</Box>
					</Grid2>
				</>
			)}
			<Dialog
				open={isPriceModalOpen}
				onClose={() => setIsPriceModalOpen(false)}
				maxWidth="sm"
				fullWidth
			>
				<DialogTitle>{t(orderResources.change)}</DialogTitle>
				<DialogContent>
					<OrderPriceEditForm
						orderPrice={orderPrice}
						orderId={orderId}
						isMaterialPrice={isMaterialPrice}
						setIsPriceModalOpen={setIsPriceModalOpen}
					/>
				</DialogContent>
			</Dialog>
		</Grid2>
	);
}
